// src/api.js
import axios from 'axios';

// Base de la API; configurable vía variable de entorno
const API_BASE =
  process.env.REACT_APP_API_BASE ||
  'http://localhost:4000';

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export const endpoints = {
  // —— revista_legal
  loginClave: () => '/api/login-clave',
  articulos: (id_sujeto) => `/api/articulos/${encodeURIComponent(id_sujeto)}`,
  articulosDisponibles: (id_sujeto) => `/api/articulos-disponibles/${encodeURIComponent(id_sujeto)}`,
  asignarArticulos: () => '/api/asignar-articulos',
  respuestas: (id_sujeto) => `/api/respuestas/${encodeURIComponent(id_sujeto)}`,
  responder: () => '/api/responder',
};
